import { useSyncExternalStore } from "react";

/** The steps of the loading screen that the app itself reports (data and assets come from elsewhere). */
export type LoadStep = "chunk" | "frame";

const done: Record<LoadStep, boolean> = { chunk: false, frame: false };
const listeners = new Set<() => void>();
let version = 0;

export function markLoaded(step: LoadStep): void {
  if (done[step]) return;
  done[step] = true;
  version += 1;
  for (const l of listeners) l();
}

export const loadedSteps = (): Readonly<Record<LoadStep, boolean>> => done;

export function useLoadVersion(): number {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => version,
  );
}

/** Weighted progress 0..1 from the four stages: scene code, world data, assets, first frame. */
export function loadProgress(p: {
  chunk: boolean;
  data: boolean;
  assets: number;
  frame: boolean;
}): number {
  return (
    (p.chunk ? 0.2 : 0) +
    (p.data ? 0.3 : 0) +
    Math.min(1, Math.max(0, p.assets)) * 0.3 +
    (p.frame ? 0.2 : 0)
  );
}
